import { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSetLogAcesso } from "~hooks/useBackOffice";
import { getPagina } from "~services/GlobalServices";
import useUsuario from "~fetchs/useUsuario";
import { getDeviceType } from "~services/utils/deviceInfo";
import { db } from "~db/db";

const useLogAcesso = () => {
  const { usuario } = useUsuario();

  const [geoLocation, setGeoLocation] = useState();

  const location = useLocation();
  const dispositivo = useMemo(() => getDeviceType(), []);

  const [pagina, setPagina] = useState("");
  const { parameter, id } = useParams();
  const parameterId = parameter ?? id;

  useEffect(() => {
    if (window.location.hostname === "localhost") return;
    const loadPagina = async () => {
      const rawSegments = location.pathname.split("/").filter(Boolean);
      const slugSegments = rawSegments.map((seg) =>
        /^\d+$/.test(seg) ? (seg === parameterId ? ":parameter" : ":number") : seg
      );
      const slug = slugSegments.join("/");
      const base = getPagina(slug) || "";

      const removePlaceholder = (str) => str.replace(/ *\{codigo\}/g, "");
      const withCodigo = (str, codigo) => str.replace(/\{codigo\}/g, codigo);

      if (!parameterId) {
        setPagina(removePlaceholder(base));
        return;
      }

      const idCliente = parseInt(parameterId, 10);
      try {
        const cliente = await db.cliente.get(idCliente);
        const codigo = cliente?.codigo;
        const label = codigo ? withCodigo(base, codigo) : removePlaceholder(base);
        setPagina(label);
      } catch {
        setPagina(removePlaceholder(base));
      }
    };

    loadPagina();
  }, [location.pathname, parameterId]);

  const saveLog = useSetLogAcesso(geoLocation, pagina, dispositivo);

  const getLocation = async () => {
    return new Promise((resolve, reject) => {
      if ("geolocation" in navigator && !usuario?.slugAcessos?.includes("nao-capturar-lat-long")) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude, accuracy } = position.coords;
            resolve({
              latitude,
              longitude,
              precisaoMetros: accuracy,
            });
          },
          (error) => {
            console.warn("Erro ao obter localização:", error.message);
            resolve({
              latitude: null,
              longitude: null,
              precisaoMetros: null,
            });
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          }
        );
      } else {
        console.warn("Geolocation não é suportado pelo seu navegador.");
        resolve({
          latitude: null,
          longitude: null,
          precisaoMetros: null,
        });
      }
    });
  };

  useEffect(() => {
    getLocation().then((e) => {
      setGeoLocation(e);
    });
  }, []);

  useEffect(() => {
    if (geoLocation && pagina) {
      saveLog();
    }
  }, [geoLocation, pagina]);
};

export default useLogAcesso;
